import React from 'react';
import classNames from 'classnames';
import styles from './amount-summary.module.scss';

interface Props {
    value: string | number;
    className?: string;
}

const AmountSummary: React.FC<Props> = ({ value, className }) => {
    return (
        <div className={classNames(styles.container, className)}>
            <p className={styles.label}>Total cost:</p>
            <span className={styles.amount}>{value}</span>
        </div>
    );
};

export default AmountSummary;
